import {
  HISTORY_PUSH,
  HISTORY_POP,
  HISTORY_REPLACE,
  GET_WAPP_HISTORY,
  GET_WAPP_HISTORY_TOP,
  HistoryPushAPI,
  HistoryPopAPI,
  HistoryReplaceAPI,
  GetWappHistoryAPI,
  GetWappHistoryTopAPI,
  Exceptions,
  WappMode,
} from '@weblite-wapps/protocol'
import { getPanelTop, popFromPanel } from 'weblite-router'
import {
  WappPanel,
  OverlayWappPanel,
  isValidStaticWapp,
  getStaticPanelByWappSessionId,
  getStaticPanelByName,
} from '$logic/wapp-panels'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'

wappSubscription.subscribe<HistoryPushAPI>(
  HISTORY_PUSH,
  async ({ state: data }, meta) => {
    if (meta.mode === WappMode.MAIN) {
      WappPanel.pushToPanel({ data })
      return { status: 'ok' }
    }

    if (isValidStaticWapp(meta)) {
      const staticPanel = getStaticPanelByWappSessionId(meta.wappSessionId)
      staticPanel?.pushToPanel({ data })

      return { status: 'ok' }
    }

    if (meta.mode === WappMode.OVERLAY) {
      OverlayWappPanel.pushToPanel({ data })
      return { status: 'ok' }
    }

    return { errorCode: Exceptions.INVALID }
  },
)

wappSubscription.subscribe<HistoryPopAPI>(HISTORY_POP, async (_, meta) => {
  if (meta.mode === WappMode.MAIN) {
    const panelTop = await getPanelTop('wapp')?.state
    if ('wappId' in panelTop) {
      // close Wapp
      await WappPanel.closeTopWapp()
      return null
    }

    popFromPanel('wapp')
    return panelTop
  }

  if (isValidStaticWapp(meta)) {
    const staticPanel = getStaticPanelByWappSessionId(meta.wappSessionId)
    const panelName = staticPanel.getName()

    const panelTop = await getPanelTop(panelName)?.state
    if (panelName !== 'vitrine' && (!panelTop || !('data' in panelTop)))
      return { errorCode: Exceptions.INVALID }

    await staticPanel.popFromPanel()
    return panelTop
  }

  if (meta.mode === WappMode.OVERLAY) {
    const panelTop = await getPanelTop('overlayWapp')?.state
    if ('wappId' in panelTop) {
      // close Wapp
      await OverlayWappPanel.closeTopWapp()
      return null
    }

    await popFromPanel('overlayWapp')
    return panelTop
  }

  return { errorCode: Exceptions.INVALID }
})

wappSubscription.subscribe<HistoryReplaceAPI>(
  HISTORY_REPLACE,
  async ({ state: data }, meta) => {
    if (meta.mode === WappMode.MAIN) {
      const panelTop = await getPanelTop('wapp')?.state
      if ('wappId' in panelTop) return { errorCode: Exceptions.INVALID }

      await WappPanel.replaceInPanel({ data })
      return { status: 'ok' }
    }

    if (isValidStaticWapp(meta)) {
      const staticPanel = getStaticPanelByWappSessionId(meta.wappSessionId)
      const panelName = staticPanel.getName()

      const panelTop = await getPanelTop(panelName)?.state
      if (!('data' in panelTop)) return { errorCode: Exceptions.INVALID }

      await staticPanel.replaceInPanel({ data })
      return { status: 'ok' }
    }

    if (meta.mode === WappMode.OVERLAY) {
      const panelTop = await getPanelTop('overlayWapp')?.state
      if ('wappId' in panelTop) return { errorCode: Exceptions.INVALID }

      await OverlayWappPanel.replaceInPanel({ data })
      return { status: 'ok' }
    }

    return { errorCode: Exceptions.INVALID }
  },
)

wappSubscription.subscribe<GetWappHistoryAPI>(
  GET_WAPP_HISTORY,
  async (_, meta) => {
    if (meta.mode === WappMode.MAIN) return WappPanel.getTopWappHistory()

    if (isValidStaticWapp(meta))
      return getStaticPanelByWappSessionId(meta.wappSessionId).getWappHistory()

    if (meta.mode === WappMode.OVERLAY)
      return OverlayWappPanel.getTopWappHistory()

    return { errorCode: Exceptions.INVALID }
  },
)

wappSubscription.subscribe<GetWappHistoryTopAPI>(
  GET_WAPP_HISTORY_TOP,
  async (_, meta) => {
    if (meta.mode === WappMode.MAIN) {
      const panelTop = await getPanelTop('wapp')?.state
      return 'wappId' in panelTop ? null : panelTop
    }

    if (isValidStaticWapp(meta)) {
      const panelTop = await getPanelTop(
        getStaticPanelByWappSessionId(meta.wappSessionId).getName(),
      )?.state

      return 'data' in panelTop ? panelTop : null
    }

    if (meta.mode === WappMode.OVERLAY) {
      const panelTop = await getPanelTop('wappOverlay')?.state
      return 'wappId' in panelTop ? null : panelTop
    }

    return { errorCode: Exceptions.INVALID }
  },
)
